import { get, del, postFile } from './base'

export const getAll = projectId => get(`tokens/${projectId}`)
export const upload = (projectId, file) => postFile(`tokens/${projectId}`, file)
export const remove = (projectId, tokenIds) => del(`tokens/${projectId}`, tokenIds)